import { createContext as e, useCallback as t, useContext as n, useEffect as r, useMemo as i, useState as a } from "react";
import { jsx as o } from "react/jsx-runtime";
var s = {
	login: {
		signIn: "Sign In",
		signingIn: "Signing in...",
		signInPrompt: "Please sign in to continue",
		username: "Username",
		password: "Password",
		client: "Client",
		warehouse: "Warehouse",
		optional: "optional",
		system: "System",
		selectSystem: "Please select a system",
		selectSystemPlaceholder: "Select a system…",
		connecting: "Connecting...",
		connectingToServer: "Connecting to server...",
		connectingRetry: "Connecting to server... (retry {{retry}}/{{max}})",
		connectionFailed: "Unable to connect to server. Please check your connection and try again.",
		retryConnection: "Retry Connection",
		loginFailed: "Login failed",
		loading: "Loading...",
		systemNotFound: "System \"{{system}}\" not found",
		rateLimited: "Too many sign-in attempts from this address.",
		lockedOut: "Too many failed sign-in attempts. Sign-in is paused here so the account is not blocked in NYCE.LOGIC.",
		retryIn: "Try again in {{seconds}} s."
	},
	launch: {
		signingIn: "Signing in…",
		missingCode: "Missing launch code.",
		expired: "This launch link has expired or was already used. Start nyceBuddy again from NYCE.LOGIC.",
		systemMismatch: "This launch link belongs to a different system.",
		failed: "Sign-in failed.",
		goToSignIn: "Go to sign in"
	},
	oauth: {
		checking: "Checking the request…",
		invalid: "This connection request cannot be used: {{reason}}",
		signInPrompt: "Sign in to connect {{client}} to nyceBuddy",
		anApplication: "an application",
		consentTitle: "Allow {{client}} to use nyceBuddy?",
		consentBody: "It will ask nyceBuddy questions and run queries as {{user}} on {{system}}, seeing what you can see.",
		consentLifetime: "The connection stays signed in until you remove it in {{client}}.",
		redirectNote: "You will be returned to {{host}}.",
		allow: "Allow",
		deny: "Deny",
		cancel: "Cancel",
		redirecting: "Returning to {{client}}…",
		mcpDisabled: "MCP is not enabled for {{system}}. Ask an administrator to turn it on.",
		otherSystem: "Choose another system",
		failed: "The connection could not be completed: {{reason}}"
	},
	chat: {
		tagline: "Your personal warehouse AI",
		welcomeMessage: "Ask me anything about your warehouse operations.",
		settings: "Settings",
		tokenUsage: "Token Usage",
		moreActions: "More",
		conversationHistory: "Conversation History",
		savedQueries: "Saved responses",
		adminFeedback: "Admin Feedback",
		feedbackResponses: "Feedback responses",
		logout: "Logout",
		newConversation: "Start a new conversation",
		typing: "nyceBuddy is thinking...",
		cancelRequest: "Cancel request",
		requestCancelled: "Request cancelled",
		inputPlaceholder: "Type your message to nyceBuddy...",
		tokenLimitReached: "Token limit reached",
		tokenLimitBanner: "Your organisation has reached its monthly token limit. Resets in {{days}} day(s) ({{date}}).",
		tokenLimitBannerScoped: "{{title}}. Resets in {{days}} day(s) ({{date}}).",
		limitScopeOrganization: "Organization limit reached",
		limitScopeTenant: "Tenant limit reached",
		limitScopeSystem: "System limit reached",
		describeAttachment: "Describe what you want to know about the attached file(s)...",
		attachFile: "Attach file (images, PDF, text, CSV, Excel)",
		removeFile: "Remove file",
		file: "File",
		send: "Send",
		thinkingNormal: "Normal",
		thinkingHigh: "High",
		thinkingExpert: "Expert",
		processingRequest: "Processing your request...",
		generatingAnswer: "Generating answer...",
		analyzingData: "Analyzing data...",
		queryingDatabase: "Querying warehouse data...",
		starting: "Starting investigation",
		connectingStatus: "Connecting…",
		reconnecting: "Connection lost, reconnecting… the answer is still being prepared",
		investigationComplete: "Investigation complete",
		investigationInterrupted: "Investigation interrupted",
		stepFinished: "Finished",
		stepStopped: "Stopped before this action completed.",
		liveActivity: "Live activity",
		activityActions: "{{count}} actions",
		step: "Step {{n}}",
		details: "Details",
		previewRows: "{{count}} rows · preview of {{shown}}",
		modelCalls: "{{calls}} model call(s) · {{nyce}} NYCE tokens",
		modelCallsPlain: "{{calls}} model call(s)",
		aiDisclaimer: "nyceBuddy can make mistakes. Check the data behind the answer.",
		formContextOn: "Questions include what you have open ({{what}}). Click to leave it out.",
		formContextOff: "Questions no longer mention what you have open ({{what}}). Click to include it again.",
		formContextDisabled: "not included",
		reuseQuestion: "Click to reuse this question",
		copyAnswer: "Copy answer",
		copied: "Copied",
		you: "You",
		steps: "{{n}} steps",
		queries: "{{n}} queries",
		query: "1 query",
		lookups: "{{n}} lookups",
		nyceTokens: "{{n}} NYCE tokens",
		stepsFailed: "{{n}} failed",
		lookup: "1 lookup",
		thinkingLevel: "thinking {{level}}",
		elapsed: "{{s}} s",
		errorPrefix: "Sorry, I encountered an error: {{message}}",
		emptyAnswer: "I wasn't able to generate a response. Please try rephrasing your question or try again later.",
		awaitingClarification: "Waiting for your answer above",
		tenant: "Tenant",
		limitReached: "Token limit reached",
		adminFeedbackTitle: "Feedback (admin)",
		feedbackScopeTenant: "Tenant",
		feedbackScopeSystem: "System",
		feedbackScopeAll: "All systems",
		feedbackFilterAll: "All",
		feedbackFilterUp: "Thumbs up",
		feedbackFilterDown: "Thumbs down",
		feedbackFilterUnhandled: "Unhandled",
		feedbackFilterHandled: "Handled",
		feedbackLoadMore: "Load more",
		feedbackMarkHandled: "Mark handled",
		feedbackUnhandle: "Unhandle",
		feedbackUnhandleConfirm: "Remove handled status?",
		feedbackMarkHandledComment: "Admin comment (optional)",
		feedbackShowToUser: "Show to user",
		feedbackHandledBy: "Handled by",
		feedbackHandledAt: "on",
		feedbackMarkResolved: "Mark as resolved",
		feedbackResolved: "Resolved",
		feedbackResolvedAt: "Resolved at",
		feedbackResolveComment: "Your comment (optional)",
		feedbackAnsweredBy: "Answered by",
		feedbackResponseNew: "New",
		feedbackHandledOn: "Answered on",
		noFeedbackResponses: "No feedback responses yet.",
		loadingFeedbackResponses: "Loading...",
		clientFilter: "Client",
		allClients: "All clients",
		warehouseFilter: "Warehouse",
		allWarehouses: "All warehouses",
		allMyClients: "All my clients",
		allMyWarehouses: "All my warehouses",
		clientNotAllowed: "You do not have access to that client.",
		warehouseNotAllowed: "You do not have access to that warehouse.",
		scopeClient: "client {{code}}",
		scopeWarehouse: "warehouse {{code}}",
		scopeAll: "all my clients",
		customerDocuments: "Documents",
		customerDocsTitle: "Your documents",
		customerDocsIntro: "Your own documents, such as ways of working and customised processes. nyceBuddy searches them next to the product documentation, for the users of this system or organisation only.",
		customerDocsAccepted: "PDF, Word, Markdown, text or HTML; up to 100 files of 20 MB each (200 MB in all).",
		customerDocsChooseFiles: "Choose files",
		customerDocsTitleField: "Title (optional)",
		customerDocsFor: "For",
		customerDocsScopeSystem: "This system",
		customerDocsScopeOrganization: "Whole organisation",
		customerDocsUpload: "Upload",
		customerDocsUploading: "Uploading...",
		customerDocsEmpty: "No documents yet.",
		customerDocsStatusPending: "Waiting",
		customerDocsStatusIndexing: "Indexing",
		customerDocsStatusReady: "Ready",
		customerDocsStatusFailed: "Failed",
		customerDocsSections: "{{count}} sections",
		customerDocsUploadedBy: "by {{user}}",
		customerDocsDownload: "Download",
		customerDocsReindex: "Re-index",
		customerDocsDelete: "Delete",
		customerDocsConfirmDelete: "Delete \"{{title}}\"? nyceBuddy stops finding it at once.",
		customerDocsErrorUnsupported: "That file type is not supported. Upload PDF, Word, Markdown, text or HTML.",
		customerDocsErrorTooLarge: "A file is too large. Each file may be at most 20 MB.",
		customerDocsErrorTooMany: "Upload at most 100 files at a time.",
		customerDocsErrorUnreadable: "The file could not be read.",
		customerDocsErrorDisabled: "Customer documents are not enabled for this system."
	},
	report: {
		table: "Table",
		chart: "Chart",
		rows: "{{count}} rows",
		rowsShown: "{{count}} rows (first {{shown}} shown)",
		frame: "frame {{n}}",
		loadingRows: "loading rows…",
		rowsArrive: "Rows arrive with the final result.",
		loadingChart: "loading data…",
		chartArrives: "Chart data arrives with the final result.",
		noNumericData: "No numeric data to chart",
		heatmap: "Heatmap",
		noHeatmapData: "No data for the heatmap",
		heatmapTruncated: "first rows and columns only",
		noValue: "No value",
		noItems: "No items",
		emptyVisualization: "Empty visualization",
		tooLarge: "Visualization too large to display ({{size}} characters, max {{max}})",
		downloadCsv: "Download CSV",
		copyTable: "Copy as text",
		copyQuery: "Copy query",
		scopeOptions: "with {{options}}",
		scopeWhere: "where {{where}}",
		showIds: "Show ID columns",
		hideIds: "Hide ID columns",
		firstPoints: "first {{count}} points",
		onTrack: "On track",
		watch: "Watch",
		critical: "Critical",
		target: "Target {{value}}",
		compare: "Compare",
		logs: "Logs",
		logsCount: "Logs ({{count}})",
		namespace: "namespace: {{ns}}",
		since: "since: {{since}}",
		truncated: "truncated",
		noLogs: "No log entries matched.",
		dataBehind: "Data behind the answer",
		pythonAnalysis: "python analysis",
		analysis: "Analysis (python)",
		codeLines: "code ({{n}} lines)",
		repaired: "repaired ×{{n}}",
		run: "run {{n}}",
		failed: "failed",
		emptyRows: "0 rows",
		note: "Note",
		loadMore: "Load {{n}} more rows",
		downloadAllCsv: "Download all {{n}} rows (CSV)"
	},
	progress: {
		queue: "Waiting for the previous question to finish",
		"queue.running": "Waiting for the previous question to finish",
		"queue.completed": "Started",
		"queue.failed": "Waiting for the previous question failed",
		routing: "Choosing the relevant schema",
		"routing.running": "Choosing the relevant schema",
		"routing.completed": "Schema chosen",
		"routing.failed": "Choosing the relevant schema failed",
		model: "Thinking",
		"model.running": "Thinking",
		"model.completed": "Thought it through",
		"model.failed": "Thinking failed",
		answer: "Writing the answer",
		"answer.running": "Writing the answer",
		"answer.completed": "Answer written",
		"answer.failed": "Writing the answer failed",
		replay: "Re-running the saved queries",
		"replay.running": "Re-running the saved queries",
		"replay.completed": "Saved queries re-run",
		"replay.failed": "Re-running the saved queries failed",
		finish: "Preparing the answer",
		"finish.running": "Preparing the answer",
		"finish.completed": "Answer prepared",
		"finish.failed": "Preparing the answer failed",
		clarify: "Asking a clarifying question",
		"clarify.running": "Asking a clarifying question",
		"clarify.completed": "Question asked",
		"clarify.failed": "Asking a clarifying question failed"
	},
	options: {
		freeTextPlaceholder: "Or type your answer…",
		rephrasePlaceholder: "Please rephrase your question with more detail…",
		malformed: "I wasn't sure how to answer that — please rephrase.",
		submit: "Submit",
		send: "Send",
		selectDate: "Select date",
		dateFrom: "From",
		dateTo: "To",
		fromTo: "from {{from}} to {{to}}"
	},
	settings: {
		title: "Settings",
		display: "Display",
		showRawData: "Show Raw Data Tables",
		showRawDataDescription: "Display raw query results while the AI is generating a response",
		fontSize: "Font Size",
		fontSizeDescription: "Adjust the overall text size of the interface",
		fontSizeSmall: "Small",
		fontSizeMedium: "Medium",
		fontSizeLarge: "Large",
		language: "Language",
		languageDescription: "Select the display language for the interface",
		theme: "Theme",
		themeDescription: "Dark, light, or follow the system setting",
		themeDark: "Dark",
		themeLight: "Light",
		themeAuto: "Auto",
		loadFailed: "Failed to load settings",
		connectFailed: "Failed to connect to server",
		saveFailed: "Failed to save setting",
		email: "Email address",
		emailDescription: "Used when you ask the assistant to \"send that to me\". Leave empty to be asked each time.",
		defaultThinking: "Default thinking level",
		defaultThinkingDescription: "Used for new conversations; the picker next to the input overrides it.",
		formContext: "Use what I have open",
		formContextDescription: "Questions carry the form and record you are looking at, so you can ask about it without naming it.",
		readAloud: "Read answers aloud",
		readAloudDescription: "When nyceBuddy reads an answer aloud: never, for questions you dictated, or always.",
		readAloudOff: "Never",
		readAloudDictated: "Dictated questions",
		readAloudAlways: "Always"
	},
	errors: {
		chatError: "Sorry, I encountered an error: {{message}}",
		unknownError: "Unknown error",
		sessionExpired: "Your session has expired. Please sign in again.",
		maxFiles: "Maximum {{max}} files allowed",
		unsupportedFileType: "Unsupported file type: {{type}}. Supported: images, PDF, text, code files, CSV, Excel.",
		fileTooLarge: "File \"{{name}}\" is too large. Maximum size is {{max}}.",
		fileReadFailed: "Failed to read file: {{name}}"
	},
	common: {
		close: "Close",
		cancel: "Cancel",
		ok: "OK",
		save: "Save",
		delete: "Delete",
		retry: "Retry",
		loading: "Loading...",
		newVersion: "A new version is available.",
		reload: "Reload",
		on: "On",
		off: "Off",
		loadMore: "Load more"
	},
	history: {
		new: "New",
		starredOnly: "Starred only",
		empty: "No saved conversations yet.",
		emptyHint: "Conversations are saved automatically after each answer.",
		untitled: "Untitled conversation",
		current: "Current",
		continue: "Continue",
		star: "Star",
		unstar: "Unstar",
		rename: "Rename",
		messages: "{{n}} messages",
		deleteConfirm: "Delete this conversation?"
	},
	memory: {
		title: "Memory",
		description: "Notes nyceBuddy keeps about your preferences and facts you told it. They are added to every conversation.",
		empty: "Nothing remembered yet.",
		clear: "Clear all",
		clearConfirm: "Forget everything nyceBuddy remembers about you?",
		"kind.preference": "preference",
		"kind.fact": "fact"
	},
	debug: {
		title: "Debug",
		step: "Step",
		model: "Model / tool",
		prompt: "Prompt",
		cached: "Cached",
		fresh: "Fresh",
		output: "Output",
		thoughts: "Thoughts",
		cacheMode: "Cache",
		ms: "ms",
		calls: "{{n}} calls",
		nyceTokens: "{{n}} NYCE tokens",
		context: "Context budget",
		contextUsed: "{{used}} of {{budget}} tokens",
		notes: "Notes",
		summary: "Summary",
		digests: "Turns",
		frames: "Frames",
		dropped: "Dropped to fit"
	},
	tool: {
		run_query: "Querying warehouse data",
		"run_query.running": "Querying warehouse data",
		"run_query.completed": "Warehouse data received",
		"run_query.failed": "Query rejected",
		run_python: "Analyzing results",
		"run_python.running": "Analyzing results",
		"run_python.completed": "Analysis done",
		"run_python.failed": "Analysis failed",
		load_entities: "Loading more schema definitions",
		"load_entities.running": "Loading more schema definitions",
		"load_entities.completed": "Schema loaded",
		"load_entities.failed": "Schema load failed",
		query_logs: "Searching server logs",
		"query_logs.running": "Searching server logs",
		"query_logs.completed": "Logs searched",
		"query_logs.failed": "Log search failed",
		search_docs: "Searching documentation",
		"search_docs.running": "Searching documentation",
		"search_docs.completed": "Documentation searched",
		"search_docs.failed": "Documentation search failed",
		search_config_tool: "Searching the Configuration Tool",
		"search_config_tool.running": "Searching the Configuration Tool",
		"search_config_tool.completed": "Configuration Tool searched",
		"search_config_tool.failed": "Configuration Tool search failed",
		clarify: "Asking a clarifying question",
		"clarify.running": "Asking a clarifying question",
		"clarify.completed": "Question asked",
		"clarify.failed": "Clarification failed",
		finish: "Preparing the answer",
		"finish.running": "Preparing the answer",
		"finish.completed": "Answer prepared",
		"finish.failed": "Finish failed",
		createMonitorAgent: "Creating the monitoring agent",
		"createMonitorAgent.running": "Creating the monitoring agent",
		"createMonitorAgent.completed": "Monitoring agent created",
		reused: "Reused an earlier result",
		"createMonitorAgent.failed": "Creating the agent failed"
	},
	usage: {
		period: "Period",
		thisMonth: "This month",
		lastMonth: "Last month",
		last30: "Last 30 days",
		last7: "Last 7 days",
		you: "You",
		tenant: "Organisation",
		tokens: "Tokens",
		promptTokens: "Prompt tokens",
		responseTokens: "Response tokens",
		nyceTokens: "NYCE tokens",
		nyceShort: "NYCE",
		inputTokens: "Input",
		cachedTokens: "Cached input",
		outputTokens: "Output",
		thinkingTokens: "Thinking",
		questions: "Questions",
		requests: "Requests",
		monthlyLimit: "Monthly limit",
		unlimited: "Unlimited",
		limitUsed: "{{pct}} % used · {{remaining}} of {{limit}} NYCE tokens left",
		scopes: "Limits that apply to you",
		scopeOrganization: "Organization",
		scopeTenant: "Tenant",
		scopeSystem: "System",
		scopeUsed: "{{used}} of {{limit}} NYCE tokens ({{pct}} %)",
		limitExceeded: "Limit reached",
		limitWarn: "Approaching the limit"
	},
	feedback: {
		up: "Good answer",
		down: "Poor answer",
		commentTitle: "What went wrong?",
		commentHelp: "Your comment and the answer are sent to the nyceBuddy team.",
		comment: "Comment",
		commentPlaceholder: "Optional: what was wrong or missing?",
		send: "Send feedback",
		thanks: "Thanks for your feedback!",
		preview: "Show answer",
		failed: "Could not send feedback"
	},
	saved: {
		save: "Save response",
		saveTitle: "Save this response",
		title: "Title",
		description: "Description",
		tags: "Tags",
		tagsHint: "Comma separated",
		search: "Search saved responses…",
		favorites: "Favourites",
		favorite: "Favourite",
		run: "Run",
		runRefresh: "Run and rewrite the commentary from fresh data",
		edit: "Edit",
		empty: "No saved responses yet.",
		emptyHint: "Save an answer with the bookmark button under it.",
		deleteConfirm: "Delete this saved response?",
		saved: "Response saved",
		replaying: "Re-running “{{title}}”"
	},
	pdf: {
		export: "Export PDF",
		exportConversation: "Export conversation (PDF)",
		failed: "PDF export failed",
		exported: "PDF downloaded",
		truncated: "Only the first {{shown}} of {{total}} messages of this conversation are included."
	},
	attachments: {
		attach: "Attach files",
		remove: "Remove {{name}}",
		uploading: "Uploading…",
		rowCount: "{{count}} rows",
		unsupported: "{{name}}: unsupported file type.",
		tooLarge: "{{name}} is larger than {{max}} MB.",
		tooManyFiles: "At most {{max}} files per question.",
		tooManyImages: "At most {{max}} images per question.",
		uploadFailed: "Upload failed.",
		dropHint: "Drop files to attach",
		too_large: "The upload is too large (at most 20 MB per file).",
		too_many_files: "At most 5 files per question.",
		too_many_images: "At most 4 images per question.",
		file_too_large: "One of the files is larger than 20 MB.",
		unsupported_file: "Unsupported file type.",
		no_files: "No file was uploaded.",
		feature_disabled: "File upload is not enabled for this system.",
		no_storage: "File upload is not available on this server."
	},
	mcp: {
		title: "MCP connection keys",
		description: "Static keys for MCP clients that can only send a header (Claude Desktop, Cursor). A key signs in as you; revoke it when a client is retired.",
		newKey: "New key",
		name: "Name",
		expiry: "Expires",
		expiryNever: "Never",
		expiryDays: "{{days}} days",
		username: "User name",
		password: "Password",
		passwordHint: "Your password is used once to obtain a separate sign-in for the key; your current session stays as it is.",
		create: "Create key",
		empty: "No keys yet.",
		created: "Created",
		lastUsed: "Last used",
		neverUsed: "never",
		"status.active": "active",
		"status.expired": "expired",
		"status.revoked": "revoked",
		"status.broken": "broken",
		revoke: "Revoke",
		revokeConfirm: "Revoke {{name}}? Clients using it stop working.",
		secretOnce: "Copy the key now; it is shown only once.",
		secret: "Key",
		url: "MCP URL",
		header: "System header",
		snippet: "Client configuration (Claude Desktop / Cursor)",
		copy: "Copy",
		copied: "Copied",
		done: "Done",
		tooManyKeys: "You already have the maximum number of keys; revoke one first.",
		badPassword: "Wrong password.",
		handOverConfirm: "Without a password the key takes over this session's sign-in; you stay signed in until the current token expires. Continue?",
		noSession: "Sign in again to create a key.",
		sessionEnds: "The key took over this session's sign-in. You stay signed in until the current token expires, then sign in again."
	},
	schedule: {
		action: "Schedule this card",
		title: "Schedule this card",
		when: "When",
		placeholder: "Send this to me at 18:00 every weekday",
		hint: "Say when in your own words, e.g. \"every weekday at 18:00\", \"daily at 07:30\", \"every Monday at 9\".",
		parsing: "Reading…",
		notUnderstood: "Could not understand when to send this. Try \"every weekday at 18:00\".",
		name: "Name",
		recipients: "Recipients",
		addRecipient: "Add an address…",
		removeRecipient: "Remove {{email}}",
		recipientsHint: "Press Enter or comma after each address.",
		recipientsFixed: "Sent to your e-mail address from Settings.",
		noEmail: "Set your e-mail address in Settings first.",
		invalidEmail: "{{email}} is not an e-mail address.",
		attachPdf: "Attach as PDF",
		create: "Create",
		created: "Scheduled: {{description}}",
		createFailed: "Could not create the schedule.",
		emailRequired: "Set your e-mail address in Settings first.",
		sendMailRequired: "You may only send scheduled cards to yourself.",
		tooMany: "You already have the maximum number of scheduled cards; delete one first.",
		scheduledMark: "Scheduled",
		sectionTitle: "Scheduled cards and agents",
		sectionDescription: "Cards sent to you by e-mail on a schedule, and agents that watch an answer and e-mail you what they find.",
		empty: "Nothing scheduled yet. Use the calendar or agent button under an answer.",
		nextRun: "next {{when}}",
		lastRun: "last sent {{when}}",
		lastRunFailed: "last run failed {{when}}",
		running: "sending now",
		to: "To",
		pdfAttached: "PDF attached",
		sendNow: "Send now",
		sent: "“{{name}}” was sent.",
		runFailed: "Sending failed. {{error}}",
		runInProgress: "This card is being sent right now; try again in a moment.",
		deleteConfirm: "Delete the scheduled card “{{name}}”?",
		kindAgent: "Agent",
		sinceLastRun: "new since the last run",
		runNow: "Run now",
		ran: "“{{name}}” ran.",
		runAsPassword: "Your password (optional)",
		runAsHint: "Used once for a separate sign-in that it runs with, so it reads only what you may read. Without it, it runs as you if you signed in for an earlier one, else with the system's own access.",
		runAsBadPassword: "Wrong password.",
		runsAsYou: "Runs as you",
		signInRequired: "Paused: your sign-in for it is no longer valid. Sign in again to resume it.",
		resume: "Resume"
	},
	agent: {
		action: "Create agent",
		title: "Create an agent from this answer",
		intro: "The agent reruns this answer on a schedule. When the result has rows, it analyses them, proposes how to resolve them and e-mails you. No rows, no e-mail.",
		loading: "Reading the answer…",
		loadFailed: "Could not read this answer: {{error}}",
		nothingToWatch: "This answer has no query results an agent could watch.",
		placeholder: "Every hour on weekdays",
		hint: "Say when in your own words, e.g. \"every hour\", \"every 15 minutes\", \"every weekday at 07:00\".",
		result: "Findings come from",
		resultHint: "Every row of this result is a finding.",
		kindTable: "table",
		kindAnalysis: "analysis",
		kindQuery: "query",
		sinceLastRun: "Only what is new since the last run",
		sinceLastRunHint: "The date filter of the queries moves to the time since the previous run.",
		noDateFilter: "The queries have no date filter, so every run looks at the same data.",
		fixedDates: "Some dates were not recognised and stay as they are.",
		showQueries: "Show the queries",
		hideQueries: "Hide the queries",
		unchanged: "unchanged",
		focus: "What should the analysis look at?",
		focusPlaceholder: "Optional, e.g. which partner is failing and why",
		create: "Create agent",
		created: "Agent created: {{description}}",
		createFailed: "Could not create the agent.",
		groupRequired: "Creating agents needs the NYCEBUDDY_CREATEAGENT group.",
		disabled: "Creating agents is switched off for this system.",
		mark: "Agent"
	},
	ask: {
		title: "Ask nyceBuddy",
		question: "Describe what you are looking for",
		placeholder: "For example: orders not picked since Monday",
		write: "Write the query",
		working: "Writing the query...",
		query: "Query",
		apply: "Run it",
		applyAnyway: "Use it anyway",
		cancel: "Cancel",
		rows: "Tried it: {{count}} row(s).",
		attempts: "Corrected itself {{count}} times.",
		unavailable: "nyceBuddy is not available here.",
		editHint: "The query is a starting point — edit it before running if it is not quite what you meant."
	},
	voice: {
		dictate: "Dictate a question",
		stop: "Stop and transcribe",
		transcribing: "Transcribing…",
		denied: "Microphone access was refused. Allow it in the browser's site settings to dictate.",
		noMicrophone: "No microphone was found.",
		failed: "The recording could not be transcribed. Try again or type the question.",
		empty: "No speech was heard. Try again a little closer to the microphone.",
		limit: "The monthly token limit is reached, so the recording was not transcribed.",
		speak: "Read aloud",
		stopSpeaking: "Stop reading",
		speakFailed: "The answer could not be read aloud.",
		handsFree: "Hands-free conversation",
		handsFreeOff: "End hands-free conversation",
		hfListening: "Listening… ask your question",
		hfHearing: "Hearing you…",
		hfTranscribing: "Transcribing…",
		hfWaiting: "Working on it…",
		hfSpeaking: "Reading the answer — speak to interrupt"
	}
}, c = s;
function l(e, t) {
	let n = t.indexOf("."), r = n > 0 ? t.slice(0, n) : "common", i = n > 0 ? t.slice(n + 1) : t;
	for (let t of e) {
		var a, o, s;
		let e = (a = (o = t[r]) == null ? void 0 : o[i]) == null ? (s = t.common) == null ? void 0 : s[i] : a;
		if (typeof e == "string") return e;
	}
}
function u(e, t) {
	return t ? e.replace(/\{\{\s*(\w+)\s*\}\}/g, (e, n) => n in t ? String(t[n]) : e) : e;
}
function d(...e) {
	let t = [...e.filter((e) => !!e), c];
	return (e, n) => {
		var r;
		return u((r = l(t, e)) == null ? e : r, n);
	};
}
var f = e({
	t: d(),
	language: "en",
	setLanguage: () => {},
	isLoading: !1,
	has: (e) => l([c], e) !== void 0
}), p = () => n(f);
function m({ language: e = "en", bundle: n, loader: s, onLanguageChange: u, children: p }) {
	let [m, h] = a(e), [g, _] = a(null), [v, y] = a(!1);
	r(() => h(e), [e]), r(() => {
		if (!s) return;
		let e = !1;
		return y(!0), s(m).then((t) => {
			!e && t && t.translations && _({
				lang: m,
				data: t.translations
			});
		}).catch(() => {}).finally(() => !e && y(!1)), () => {
			e = !0;
		};
	}, [m, s]);
	let b = n ? "translations" in n ? n.translations : n : void 0, x = i(() => [b, (g == null ? void 0 : g.lang) === m ? g.data : void 0], [
		b,
		g,
		m
	]), S = i(() => d(...x), [x]), C = t((e) => l([...x.filter((e) => !!e), c], e) !== void 0, [x]), w = t((e) => {
		h(e), u == null || u(e);
	}, [u]), T = i(() => ({
		t: S,
		language: m,
		setLanguage: w,
		isLoading: v,
		has: C
	}), [
		S,
		m,
		w,
		v,
		C
	]);
	return /* @__PURE__ */ o(f.Provider, {
		value: T,
		children: p
	});
}
// src/i18n/nyceCodes.ts
var h = {
	ENG: "en",
	SWE: "sv",
	NLD: "nl",
	DEU: "de",
	DAN: "da",
	NOR: "no",
	FIN: "fi",
	FRA: "fr",
	POL: "pl"
};
function g(e, t) {
	if (!e) return "en";
	let n = e.trim().toUpperCase(), r = t == null ? void 0 : t.find((e) => {
		var t;
		return (t = e.nyceLogicCodes) == null ? void 0 : t.some((e) => e.toUpperCase() === n);
	});
	if (r) return r.code;
	if (h[n]) return h[n];
	let i = e.trim().toLowerCase();
	return /^[a-z]{2}(-[a-z]{2})?$/i.test(i) ? i.slice(0, 2) : "en";
}
function _() {
	return typeof navigator > "u" ? "en" : (navigator.language || "en").slice(0, 2).toLowerCase();
}
// src/i18n/status.ts
function v(e, t, n) {
	let r = n.state || "running", i = [];
	n.titleKey && (/\.(running|completed|failed|interrupted)$/.test(n.titleKey) ? i.push(n.titleKey, n.titleKey.replace(/\.(running|completed|failed|interrupted)$/, "")) : i.push(`${n.titleKey}.${r}`, n.titleKey)), n.tool && i.push(`tool.${n.tool}.${r}`, `tool.${n.tool}`), n.stage && i.push(`progress.${n.stage}.${r}`, `progress.${n.stage}`);
	for (let n of i) if (t(n)) return e(n);
	return n.message || n.tool || n.stage || "";
}
export { m as a, p as c, g as i, s as l, h as n, u as o, _ as r, d as s, v as t };

//# sourceMappingURL=i18n-QsyhtsgC.js.map